import { http } from "./http";

export type AuthInput = {
    email: string;
    password: string;
  };

  export type LoginResponse = {
    token: string;
    user: {
      id: string;
      email: string;
      name?: string;
      avatarUrl?: string;
    };
  };


  export type RegisterInput = {
    firstName: string;
    lastName: string;
    email: string;
    password: string;

    /**
     * Fullständigt födelsedatum, YYYY-MM-DD.
     *
     * Servern räknar 18-årsgränsen på månad och dag och sparar sedan bara
     * årtalet. Ett årtal ensamt räckte inte: någon född i december 2008
     * fyller 18 först i december 2026.
     */
    birthDate: string;

    // Kryssrutan är obligatorisk och servern sparar vilken version som
    // godkändes. Klienten skickar tillbaka exakt den version den visade,
    // så en användare aldrig kan bokföras på en text de inte såg.
    acceptTerms: boolean;
    termsVersion: string;
  };

  // TODO: fix types
  export type RegisterResponse = {
    token: string;
    user: {
      id: string;
      email: string;
      name?: string;
      avatarUrl?: string;
    };
  };

  export type Role = "USER" | "CONTRIBUTOR" | "ADMIN" | "SUPERADMIN";

  export type MeResponse = {
    id: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    avatarUrl?: string | null;
    bio?: string | null;
    yearOfBirth?: number | null;
    emailVerified?: boolean;
    role: Role;
  };

  /** Villkorsversionen bor i backend, se api/legal.js. */
  export type LegalMeta = {
    termsVersion: string;
    termsUpdatedAt: string;
    privacyVersion: string;
    privacyUpdatedAt: string;
    contactEmail: string;
  };
  

export function login(data: AuthInput) {
  return http.post<LoginResponse>("/auth/login", data);
}

export function register(data: RegisterInput) {
return http.post<RegisterResponse>("/auth/register", data);
}

export function me() {
  return http.get<MeResponse>("/me"); 
}

export function getLegalMeta() {
  return http.get<LegalMeta>("/legal");
}

/**
 * Begär en återställningslänk.
 *
 * Svarar likadant oavsett om adressen finns — se api/authRoutes.js. Därför
 * ska klienten också visa samma kvitto i båda fallen, annars läcker
 * gränssnittet det API:et var noga med att inte göra.
 */
export function forgotPassword(email: string) {
  return http.post<{ ok: true }>("/auth/forgot-password", { email });
}

export function resetPassword(input: { token: string; password: string }) {
  return http.post<{ ok: true }>("/auth/reset-password", input);
}

export function verifyEmail(token: string) {
  return http.post<{ ok: true }>("/auth/verify-email", { token });
}

export function confirmEmailChange(token: string) {
  return http.post<{ ok: true; email: string }>("/auth/confirm-email-change", { token });
}
